import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import ListaFiltros from './componentes/ListaFiltros';
import { activeDialog } from '../../../../utils/Common';
import InputPlaneacion from './componentes/ImputPlaneacion';
import DisponibilidadCamas from './componentes/DisponibilidadCamas';
import AvanceEstadosBotones from './componentes/AvanceEstadosBotones';
import ListaPlanesAsociados from './componentes/ListaPlanesAsociados';
import Ajustadores from './componentes/Ajustadores';
import ListadoBloquesValvulas from './componentes/selectorCamasValvula/ListadoBloquesValvulasV2';
import EncabezadosTabla from './componentes/EncabezadosTabla';
import { set } from 'lodash';

const PlaneacionCampo = () => {
    const [filtros, setfiltros] = useState({ semana: [], flor: [], variedad: [], color: [] });
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [data, setdata] = useState([]);
    const [nuevasPlaneaciones, setnuevasPlaneaciones] = useState([]);
    const [dataOriginal, setdataOriginal] = useState([]);
    const filtrosKeys = ['semana', 'flor', 'variedad', 'color'];
    const [apiFiltros, setapiFiltros] = useState({ 'semana': "", 'flor': '', 'variedad': '', 'color': '', completos: 0, planeados: 0, incluir_inventario: 0 });
    const [camasData, setcamasData] = useState([]);
    const [showCamasMenu, setshowCamasMenu] = useState(false);
    const [detallesPlanes, setdetallesPlanes] = useState(null);
    const [valvulasRanchos, setvalvulasRanchos] = useState({ valvulas: [], ranchos: [] });
    const [detallesCamas, setdetallesCamas] = useState(null);
    const [listadoValvulas, setlistadoValvulas] = useState([]);
    const [vistaExtendida, setvistaExtendida] = useState(true);
    const [campos_plan, setcampos_plan] = useState([
        { key: 'semana_transplante', input: true, type: 'text', fancyName: 'S. TRASP.' },
        { key: 'dia_trasplante', input: true, type: 'number', fancyName: 'DÍA TRASP.' },
        { key: 'semana_cosecha', input: true, type: "text", fancyName: 'S. CORTE' },
        { key: 'dia_cosecha', input: true, type: "number", fancyName: 'DÍA CORTE' },
        { key: 'plantas_plan', input: true, type: "number", fancyName: 'PL. PLAN' },
        { key: 'rancho', input: false, options: [...valvulasRanchos.ranchos], fancyName: 'RANCHO' }]);
    const ajustadores = new Ajustadores();
    var refrescos = 0;

    useEffect(() => {
        if (refrescos > 0) getData();
        refrescos++;
        getData(); getStaticForms();
    }, []);

    const getDataAPI = async (uri, data = {}) => {
        let resp = await Post(uri, data, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return false;
        }
        return resp;
    }

    const getStaticForms = async () => {
        let resp = await getDataAPI('campo/v2/forms/estatics');
        if (resp) {
            setvalvulasRanchos({ ...resp.data });
            let cp = [...campos_plan];
            cp[5].options = resp.data.ranchos;
            setcampos_plan(cp);
        }
    }

    const getData = async (filtros) => {
        if (filtros) setapiFiltros(filtros);
        else filtros = { ...apiFiltros };
        let resp = await getDataAPI('campo/v2/getSalidasViveroMultiples', filtros);
        if (resp) asignarDatos(resp, filtros);
    }

    const changeVal = (event) => {
        let { name, value } = event.target;
        let fl = { ...apiFiltros, [name]: value };
        setapiFiltros(fl);
        getData(fl);
    }

    const asignarDatos = (resp, filtros = { ...apiFiltros }) => {
        let registrosConRancho = ajustadores.agregarRanchoSeleccionadoARegistros(resp.data, data);
        setdataOriginal([...registrosConRancho]);
        setdata([...registrosConRancho]);
        setfiltros({ ...resp.filtros });
        setnuevasPlaneaciones({});
        setapiFiltros({ ...filtros, ['semana']: resp.semana });
        setcamasData([...resp.camas]);
        setlistadoValvulas(ajustadores.extraerValvulas(resp.camas));
    }

    const getDiasSiembra = (reg) => {
        let dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
        let sembrados = [];
        for (let i = 0; i < 6; i++) if (reg[dias[i]]) sembrados.push(i + 1);
        return sembrados.join(', ');
    }

    const aplicarFiltro = (event) => {
        let name = event.target.name;
        let fl = { ...apiFiltros };
        fl[name] = fl[name] === 1 ? 0 : 1;
        getData(fl);
    }

    const actualizarPlanes = async (registros) => {
        let filtros = { ...apiFiltros };
        filtros.registros = Array.isArray(registros) ? registros : Object.values(nuevasPlaneaciones);
        let resp = await getDataAPI('campo/v2/actualizarPlanesCampo', filtros);
        if (resp) { asignarDatos(resp); }
    }

    const agregarAInventario = async (id, origen) => {
        let filtros = { ...apiFiltros };
        filtros.plan = id;
        filtros.origen = origen;
        let resp = await getDataAPI('campo/v2/inventario/agregar', filtros);
        if (resp) { asignarDatos(resp); }
    }

    const updatePlan = (event, index) => {
        let { name, value } = event.target;
        let newData = [...data];
        newData[index] = { ...newData[index], [name]: value }; // Crear una copia del objeto antes de modificarlo
        if (name === 'valvula') {
            newData[index].cama_inicio = newData[index].cama_fin = null;
            newData[index].metros_inicio = newData[index].metros_fin = 0;
            newData[index].tunel = "";
        }
        setdata(newData);
        modificaciones(newData, true);
    }

    const updateCamasTuneles = (dt, index, subIndex) => {
        //Subindex solo se envia cuando se trata de modificar un plan existente, si no se envia se trata de un nuevo plan
        let newData = JSON.parse(JSON.stringify(data));
        if ([undefined, null].includes(subIndex) || subIndex < 0) {
            newData[index].cama_inicio = dt.cama_inicio;
            newData[index].cama_fin = dt.cama_fin;
            newData[index].tunel = dt.tunel;
            newData[index].metros_inicio = dt.metros_inicio;
            newData[index].metros_fin = dt.metros_fin;
            newData[index].valvula = dt.valvula;
        } else {
            newData[index].planes[subIndex].cama_inicio = dt.cama_inicio;
            newData[index].planes[subIndex].cama_fin = dt.cama_fin;
            newData[index].planes[subIndex].tunel = dt.tunel;
            newData[index].planes[subIndex].metros_inicio = dt.metros_inicio;
            newData[index].planes[subIndex].metros_fin = dt.metros_fin;
            newData[index].planes[subIndex].actualizar = true;
            newData[index].planes[subIndex].valvula = dt.valvula;
        }

        setdata(newData);
        if (!subIndex) modificaciones(newData, true);
        setdetallesCamas(null);
    }

    //Verifica que registros estan editados respecto a los originales y genera un arrray con los datos listos para ser enviado l backend
    const modificaciones = (newData = { ...data }, update = false) => {
        let modificados = {};
        let len = newData.length;
        let counter = 0;
        for (let i = 0; i < len; i++) {
            let mod = false;
            for (let key of campos_plan) {
                if (newData[i][key.key] !== dataOriginal[i][key.key]) {
                    mod = true;
                    break;
                }
            }
            if (mod) {
                if (update) {
                    modificados[i] = {
                        id: newData[i].planeacion_id,
                        plan_cosecha_id: newData[i].id,
                        semana_transplante: newData[i].semana_transplante,
                        dia_transplante: newData[i].dia_trasplante,
                        semana_cosecha: newData[i].semana_cosecha,
                        dia_cosecha: newData[i].dia_cosecha,
                        valvula: newData[i].valvula,
                        rancho: newData[i].rancho,
                        tunel: newData[i].tunel,
                        cama_inicio: newData[i].cama_inicio,
                        cama_fin: newData[i].cama_fin,
                        plantas_plan: +newData[i].plantas_plan,
                        metros_inicio: newData[i].metros_inicio ?? 0,
                        metros_fin: newData[i].metros_fin ?? 0,
                        origen: newData[i].origen
                    };
                }
                counter++;
            }
        }

        if (update) setnuevasPlaneaciones(modificados);
        return counter;
    }

    const confirmarFinalizar = (plan_siembra) => {
        setdialog({
            tipo: 'error',
            show: true,
            title: 'Finalizar Plan de campo',
            body: `¿Desea finalizar la planeación de campo? Si la planeación concluye no será posible realizar cambios`,
            funct: (resp) => { if (resp) finalizarPlan(plan_siembra); setdialog({ show: false }) },
            size: 'm',
            respYes: "Si finalizar",
            respNot: "Cancelar"
        })
    }

    const finalizarPlan = async (plan_siembra) => {
        let data = { ...apiFiltros };
        data.plan = plan_siembra;
        let resp = await getDataAPI('campo/v2/planes/finalizar', data);
        if (resp) asignarDatos(resp);
    }

    //Verifica si un registro pertenece a un plan que ya fué concluido y solo se puede visualizar
    const plan_concluido = (data) => {
        if (data.planes.length === 0) return false;
        for (let i = 0; i < data.planes.length; i++)
            if (data.planes[i].planes_completos === 1) return true;
        return false;
    }

    //Elimina un registrode inventario para que un plan pueda ser modificado siempre que no este concluido
    const deshacerInvetario = async (id) => {
        let data = { ...apiFiltros };
        data.plan = id;
        let resp = await getDataAPI('campo/v2/planes/deshacer', data);
        if (resp) asignarDatos(resp);
    }

    const abrirDetallesDeCamasValvulas = (reg, key, tipo, index, subindex, planeacion_campo_id = null) => {

        if ([undefined, null, ""].includes(reg[key])) return;
        setdetallesCamas({
            id: +reg[key],
            index: index,
            subindex: subindex,
            dia: reg.dia_trasplante,
            semana: reg.semana_transplante,
            valvula_id: reg.valvula,
            tipo: tipo, //tipo es la planeacion desde el renglon princpal o desde los planes asociados
            metros: reg.plantas_plan > 0 ? `${Math.ceil(reg.plantas_plan / reg.densidad)} mt. cuadrados` : "Plantas no definidas",
            cama_fin: reg.cama_fin,
            cama_inicio: reg.cama_inicio,
            metros_inicio: reg.metros_inicio ?? 0,
            metros_fin: reg.metros_fin ?? 0,
            planeacion_campo_id: planeacion_campo_id,
            inventariado: reg.inventariado ? true : false,
        })
    }

    /**
    * Retorna las diferencias en semanas entre la semana de siembra planeada y la semana de ejecución
    * @param {object} p - un elemento del plan de siembra de la lista alojada en data
    * @returns {number} numero de semanas de diferencia respecto a semana de siembra planeada
   */
    const diferencia = (p) => {
        if (p.semana_ejecucion && p.fecha_inicio) {
            let inicio = new Date(p.fecha_inicio);
            let ejecucion = new Date(p.fecha_semana_ejecucion);

            let diferencia = ejecucion - inicio;
            let dias = diferencia / (1000 * 60 * 60 * 24);
            let semanas = dias / 7;
            return Math.floor(semanas);
        }
        return 0;
    }

    const semana_ejecucion = (p) => {
        if (p.semana_ejecucion) return p.semana_ejecucion;
        return p.semana_siembra;
    }

    return (
        <div className='vw-100 p-2 overflow bg-white p-2 dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-150 mt-2 contenedor'>
                    <button className={'w-100 btn btn-sm border border-3 border-info text-bold shadow btn-light'}
                        onClick={() => { if (!showCamasMenu) setshowCamasMenu(true); }}
                    >Camas</button>
                </div>
                <div className='bw-150 mt-1 contenedor'>
                    <button className={'w-100 m-0 btn btn-sm border border-3 border-warning text-bold shadow btn-' + (apiFiltros.completos === 1 ? 'warning' : 'light')}
                        name='completos' onClick={aplicarFiltro}
                    >Listo para envio</button>
                </div>
                <div className='bw-150 mt-1 contenedor'>
                    <button className={'w-100 m-0 btn btn-sm border border-3 border-warning text-bold shadow btn-' + (apiFiltros.planeados === 1 ? 'warning' : 'light')}
                        name='planeados' onClick={aplicarFiltro}
                    >Planificados</button>
                </div>
                <ListaFiltros keys={filtrosKeys} filtros={filtros} funcion={changeVal} values={apiFiltros} containerStyle={'form-group col-auto'} />
                <div className='bw-150 m-0 contenedor'>
                    {Object.keys(nuevasPlaneaciones).length > 0 &&
                        <button className='w-100 btn btn-sm m-0  btn-sm btn-warning scale-continue-05 text-bold border border-2 border-dark w-100' onClick={actualizarPlanes}>Guardar Cambios</button>}
                </div>
                <div className='w-100 m-0 p-0' />
            </div>

            <div className='w-100 p-0 shadow border border-2 mt-3 round-m bg-white vh-75' style={{ overflow: "auto" }}>
                <table className='table table-sm text-s table-bordered table-hover'>
                    <EncabezadosTabla funcion={() => setvistaExtendida(!vistaExtendida)}
                        encabezados={vistaExtendida ?
                            ['AVANCE DE ESTADOS', 'BLOQUE', 'CHAROLAS', 'PRESUP.', 'PL. REALES', 'PL. ASIGNADAS', 'DENSIDAD', 'METROS2', 'DESFASE', 'S. SIEMBRA', 'DIA SIEMBRA', 'S. TRASP.', 'DÍA TRASP.', 'S. CORTE', 'DÍA CORTE', 'PL. PLAN', 'RANCHO', 'VALVULA', 'CAMAS'] :
                            ['AVANCE DE ESTADOS', 'BLOQUE', 'CHAROLAS', 'PRESUP.', 'PL. REALES', 'PL. ASIGNADAS', 'DENSIDAD', 'METROS2', 'DIA SIEMBRA', 'S. TRASP.', 'DÍA TRASP.', 'S. CORTE', 'DÍA CORTE', 'PL. PLAN', 'RANCHO', 'VALVULA', 'CAMAS']
                        } />
                    <tbody style={{ position: "relative" }}>
                        {
                            data.map((reg, index) =>
                                <React.Fragment key={"data" + index}>
                                    <tr >
                                        <td className={'text-start bw '} style={{ minWidth: "130px", position: "sticky", left: "0" }}>
                                            <AvanceEstadosBotones data={reg} open={detallesPlanes === reg.id}
                                                detalles={() => setdetallesPlanes(detallesPlanes === reg.id ? null : reg.id)} />
                                        </td>
                                        <td className={'text-start nowrap text-bold ' + (nuevasPlaneaciones[index] ? " text-red3" : "")} style={{ position: "sticky", left: "0" }}>
                                            {reg.bloque}
                                        </td>
                                        {(
                                            vistaExtendida ? ['charolas', 'presupuesto', 'plantas', 'plantas_asignadas', 'densidad', 'metros2_siembra'] :
                                                ['charolas', 'presupuesto', 'plantas', 'plantas_asignadas', 'densidad', 'metros2_siembra']
                                        ).map((key, i) => <td key={i + "index"} className='text-center nowrap bw-150'>{reg[key]}</td>)
                                        }

                                        {vistaExtendida && <td className={'text-center nowrap bw-150 ' + (diferencia(reg) != 0 ? 'rosa-retrasado border border-white' : '')}>{diferencia(reg)}</td>}
                                        {vistaExtendida && <td className='text-center nowrap'>{semana_ejecucion(reg)}</td>}
                                        <td className='text-center nowrap' scope='row'>{getDiasSiembra(reg)}</td>

                                        {campos_plan.map((key, i) => <td key={index + 'input' + i} style={key.key === 'valvula' ? { minWidth: "130px", maxWidth: "120px" } : { minWidth: "75px", maxWidth: "75px" }} >
                                            <div className='row justify-content-evenly w-100 m-0 p-0'>
                                                <InputPlaneacion
                                                    input={key.input} options={key.options} name={key.key}
                                                    typeInput={key.type} value={reg[key.key]}
                                                    className={key.key == 'valvula' ? 'form-control form-control-sm m-0 w-70' : 'form-control form-control-sm m-0'}
                                                    funcion={(e) => updatePlan(e, index)}
                                                />
                                            </div>
                                        </td>)
                                        }
                                        <td key={index + 'valv'} style={{ minWidth: "130px", maxWidth: "120px" }}>
                                            <div className='row justify-content-evenly w-100 m-0 p-0'>
                                                <InputPlaneacion
                                                    input={false} options={ajustadores.filtrarValvulasPorRancho(reg.rancho, [...valvulasRanchos.valvulas])} name={'valvula'}
                                                    typeInput={""} value={reg.valvula}
                                                    className={'form-control form-control-sm m-0 w-70'}
                                                    funcion={(e) => updatePlan(e, index)}
                                                />
                                                <div className={'w-20 round-s shadow text-center  text-bold text-l ' + ([undefined, null, ""].includes(reg.valvula) ? ' bg-light opacity-50' : ' bg-warning pointer scale-05')}
                                                    onClick={() => abrirDetallesDeCamasValvulas(reg, 'valvula', 'nuevo', index, null)}>i</div>

                                            </div>
                                        </td>
                                        {/*{ key: 'valvula', input: false, options: [...valvulasRanchos.valvulas], fancyName: 'VALVULA' }*/}
                                        <td className={'text-center nowrap ' + (nuevasPlaneaciones[index] ? " text-bold text-red3" : "")}
                                        >{reg.cama_inicio ?? 0} - {reg.cama_fin ?? 0}</td>
                                    </tr>
                                    {detallesPlanes === reg.id && <ListaPlanesAsociados
                                        cerrar={() => setdetallesPlanes(null)}
                                        colSpan={vistaExtendida ? 19 : 17}
                                        data={reg}
                                        index={index}
                                        close={() => setdetallesPlanes(null)}
                                        campos_plan={campos_plan}
                                        valvulasRanchos={valvulasRanchos}
                                        actualizarPlanes={actualizarPlanes}
                                        agregarAInventario={agregarAInventario}
                                        finalizar={confirmarFinalizar}
                                        concluido={plan_concluido(reg)}
                                        deshacerInvetario={deshacerInvetario}
                                        abrirDetallesDeCamasValvulas={abrirDetallesDeCamasValvulas}
                                        valvulas={[...valvulasRanchos.valvulas]}
                                    />}
                                </React.Fragment>
                            )
                        }
                    </tbody>
                </table>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
            {showCamasMenu && <DisponibilidadCamas data={camasData} semana={apiFiltros.semana} close={() => setshowCamasMenu(false)} />}
            {detallesCamas && <ListadoBloquesValvulas data={detallesCamas} close={() => setdetallesCamas(null)} save={updateCamasTuneles} valvulas={listadoValvulas} />}
        </div>
    )
}

export default PlaneacionCampo;